import { useState, useEffect } from 'react';

import AllSitesModel from './AllSitesModel';

export function useSitesByType(props) {
    const { status, type, enabled = true } = props || {};
    const [sites, setSites] = useState(null);

    const createSite = async (data) => {
        const model = new AllSitesModel({
            isAdmin: true,
        });
        data.type = type || data.type || null;
        return await model.createSite(data);
    };

    const updateSite = async (id, data) => {
        const model = new AllSitesModel({
            isAdmin: true,
        });
        data.type = type || data.type || null;
        return await model.updateSite(id, data);
    };

    useEffect(() => {
        if (!enabled) {
            setSites(null);
            return undefined;
        }

        const onUpdate = async (list) => {
            setSites(list);
        };

        const model = new AllSitesModel({
            status,
            type,
            isAdmin: true,
            onUpdate,
        });

        model.start();

        return function cleanup() {
            model.stop();
            setSites(null);
        };
    }, [status, type, enabled]);

    return [sites, createSite, updateSite];
}
